import { FC } from 'react';
import { IProductList, ORDER_STATUS_NAME_TRIM, PAYMENT_TYPES } from '../../../../../../types/orders';
import { NudosSelectButton } from '../../../../../../components/NudosComponents';
import { formatShortDate } from '../../../../../../utils/formatDatesAndHours';
import IconCheckMark from '../../../../../../assets/images/orders/IconCheckMark';
import { IconTimeClock } from '../../../../../../assets/DesignSystem/SVGComponents';

import './FooterDetailsRight.scss';

interface IFooterDetailsRightProps {
  orderData: IProductList;
  showComponent?: boolean;
  handleUploadPaymentLink?: () => void;
}
const FooterDetailsRight: FC<IFooterDetailsRightProps> = ({
  orderData,
  showComponent = false,
  handleUploadPaymentLink
}: IFooterDetailsRightProps) => {
  const { statusName, paymentLink, paymentType, commitedPaymentDate, proofOfPaymentUrl, hasPendingConfig } = orderData;

  const orderIsCanceled = statusName?.toLowerCase().trim() === ORDER_STATUS_NAME_TRIM.CANCELLED;
  const orderAlreadyDelivered = statusName?.toLowerCase().trim() === ORDER_STATUS_NAME_TRIM.DELIVERED;
  const COPCard = paymentType?.trim() === PAYMENT_TYPES.CARD_COP;
  const activeOrder = !orderIsCanceled && !orderAlreadyDelivered;
  const formattedCommittedPaymentDate = formatShortDate(commitedPaymentDate)?.onlyDate;

  const shouldHideProofOfPayment = [
    PAYMENT_TYPES.CARD_MXN,
    PAYMENT_TYPES.INTERNATIONAL_CARD,
    PAYMENT_TYPES.TRANSFER_MXN
  ].includes((paymentType || '') as PAYMENT_TYPES);

  const orderWithAdditionalSettings = hasPendingConfig;

  const showUploadPaymentLink = activeOrder && COPCard && !paymentLink && !orderWithAdditionalSettings;
  const orderConfirmation =
    activeOrder && (!COPCard || paymentLink) && !shouldHideProofOfPayment && !orderWithAdditionalSettings;
  const confirmationWithReceipt = orderConfirmation && !commitedPaymentDate;
  const confirmationWithPaymentAgreement = orderConfirmation && commitedPaymentDate;

  if (!showComponent) return <></>;
  return (
    <div className="footerDetailsRight">
      {orderWithAdditionalSettings && (
        <div className="additionalSettings">
          <div className="redText">Configuraciones adicionales ⚠️</div>
        </div>
      )}
      {showUploadPaymentLink && (
        <button className="paymentLink" onClick={handleUploadPaymentLink}>
          Cargar link de pago
        </button>
      )}
      {confirmationWithReceipt && (
        <div className="proofOfPayment">
          <em className="text">Comprobante</em>
          <NudosSelectButton
            customClassName="proofOfPaymentSelectButton"
            colorPalette="black"
            isButtonActive={!!proofOfPaymentUrl}
          />
        </div>
      )}
      {confirmationWithPaymentAgreement && (
        <div className="committedPaymentDateAndProofOfPayment">
          {proofOfPaymentUrl && <IconCheckMark className="iconCheckMark" />}
          {!proofOfPaymentUrl && <IconTimeClock className="iconTimeClock" />}
          <em className={`text ${proofOfPaymentUrl ? 'proofOfPaymentUrl' : ''}`}>
            Acuerdo {formattedCommittedPaymentDate}
          </em>
        </div>
      )}
    </div>
  );
};

export default FooterDetailsRight;
